import React from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import Card from '../../components/elements/Card';
import Image from '../../components/images/Image';
import { useEffect, useState } from 'react';
import { fetchUserInfo, teamPhoto } from '../../utils';
import Back from '../../components/common/Back';
import Center from '../../components/css/Center';
import Icon from '../../components/common/Icon';
import SameLine from '../../components/css/SameLine';
import NotFound from '../../components/common/NotFound';


const Page = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserInfo('/cheers-leaderboard', setUserInfo, setLoading, setError);
  }, []);
  

  return (
    <Base activeNav="home">
        <Back to='/home' />
        <Title my='0' className='mt-4 mb-2'>{t('cheersLeaderboard')}</Title>
        {userInfo?.leaderboard_quarter && <div className='px-3 text-secondary mb-3'>{t('leaderboardQuarters', { quarter: userInfo?.leaderboard_quarter})}</div> }

        {userInfo?.teams?.length > 0 ? (
            <>
            {userInfo?.teams.map((team, index) => (
                <Card 
                    key={team.id} 
                    to="/team" 
                    onClick={() => sessionStorage.setItem('otherTeamId', team.id)} 
                    mx='3' 
                    mb='2' 
                    className={`${team.id === userInfo.user_team_id ? 'btn-primary' : ''}`}
                >
                     <SameLine className="row">
                        {/* LEFT SIDE: Image */}
                        <div className='col-4 d-flex align-items-center'>
                        <Image 
                            url={teamPhoto(team.photo_url, team.company_picture)}
                            size="7rem" 
                            className="me-2"
                        />
                        </div>

                        {/* RIGHT SIDE: Cheers, Name, Company */}
                        <div className='col-8 text-center d-flex flex-column justify-content-center' style={{ marginLeft: '-0.8rem'}}>
                        <div style={{ fontSize: '2rem', fontWeight: '800', color: team.id === userInfo.user_team_id ? 'white' : 'var(--primary-color)'  }}>
                            {team.cheer_count} <Icon name='party-horn' theme='primary' style={{ fontSize: '1.8rem'}}  />
                        </div>
                        <div style={{ fontSize: '1rem', fontWeight: '600' }}>
                            {team.name}
                        </div>
                        <div className="text-secondary" style={{ fontSize: '0.85rem' }}>
                            {team.company_name}
                        </div>
                        </div>
                    </SameLine>

                    {/* Bottom-right Rank */}
                    <div style={{
                        position: 'absolute',
                        bottom: '0.4rem',
                        right: '0.6rem',
                        fontSize: '0.8rem',
                        color: team.id === userInfo.user_team_id ? 'white' : '#6c757d'
                    }}>
                            #{index + 1}
                    </div>
                </Card>
                ))}
            </>
        ) : (
          <NotFound translationKey="noLeaderboardFound" loading={loading} />
        )}

    </Base>
  );
};

export default Page;